import React, { useState } from "react";
import {
  Sheet,
  SheetContent,
  SheetDescription,
  SheetHeader,
  SheetTitle,
  SheetTrigger,
} from "../../../shadcn/components/ui/sheet";
import { ChevronRightIcon } from "lucide-react";
import BidderDetailsModal from "./BidderDetailsModal";

interface BidderGroupListProps {
  bidders: any[];
  refreshPage: () => void;
}

export const BidderGroupList: React.FC<BidderGroupListProps> = ({
  bidders,
  refreshPage,
}) => {
  const [selectedPerson, setSelectedPerson] = useState<any>([]);
  const [openModal, setOpenModal] = useState<any>(false);
  const formatDateTime = (isoString: string) => {
    const date = new Date(isoString);

    const time = new Intl.DateTimeFormat("en-GB", {
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    })
      .format(date)
      .toUpperCase();

    const fullDate = new Intl.DateTimeFormat("en-GB", {
      day: "numeric",
      month: "short",
      year: "numeric",
    }).format(date);

    return { time: time, date: fullDate };
  };

  return (
    <Sheet open={openModal} onOpenChange={setOpenModal}>
      <ul>
        {bidders?.map((person, index) => (
          <SheetTrigger asChild key={person.uuid}>
            <li
              key={index}
              onClick={() => setSelectedPerson(person)}
              className="relative flex border-t cursor-pointer justify-between gap-x-6 px-4 py-2 hover:bg-gray-50"
            >
              <div className="flex min-w-0 gap-x-4">
                <div className="min-w-0 flex-auto">
                  <p className="text-xs md:text-sm/6 font-normal text-gray-900">
                    KYC request{" "}
                    {person?.meta?.is_re_kyc ? "Re-submitted" : "submitted"} by{" "}
                    <br className="lg:hidden" />
                    <span className="font-semibold">{person?.meta?.name}</span>
                  </p>
                  {/* <p className=" flex text-xs/5 text-gray-500">
                      {person.email}
                    </p> */}
                </div>
              </div>
              <div className="flex shrink-0 items-center gap-x-4">
                <div className="hidden sm:flex sm:flex-col sm:items-end">
                  <p className="mt-1 text-sm text-black">Submitted on: </p>
                  <p className=" flex text-xs/5 text-gray-500">
                    {formatDateTime(person?.updated_at)?.time}
                    {", "}
                    {formatDateTime(person?.updated_at)?.date}
                  </p>
                </div>
                <ChevronRightIcon
                  aria-hidden="true"
                  className="size-5 flex-none text-gray-400"
                />
              </div>
            </li>
          </SheetTrigger>
        ))}
      </ul>

      <SheetContent
        side="right"
        className=" sm:max-w-full w-full  sm:w-2/3 lg:w-3/4 overflow-y-auto"
      >
        <SheetHeader>
          <SheetTitle className="" />
          <SheetDescription>{selectedPerson?.role}</SheetDescription>
        </SheetHeader>
        <BidderDetailsModal
          handleCloseModal={setOpenModal}
          refreshPage={refreshPage}
          bidderData={selectedPerson}
        />
      </SheetContent>
    </Sheet>
  );
};
